import {useEffect,useState} from 'react';
import {api} from '../api';
import {Link} from '../ui/ScopedLink';
import {useCapability,useStaffSession} from '../ui/StaffSession';
import {withBuildingScope} from '../ui/building-scope';

/**
 * "Needs details" on a document filed with details to confirm (fileWithOpenDecisions): its open engine questions, each
 * linking to its card in the engine queue. Shows nothing when there are none or the reader cannot manage documents.
 */
export function DocumentOpenQuestions({documentId}:{documentId:string}){
 const session=useStaffSession(),canManage=useCapability('documents:manage');
 const building=session?.effectiveScope.kind==='building'?session.effectiveScope.id:undefined;
 const [items,setItems]=useState<Array<{id:string;question:string;engineName:string;overdue:boolean}>>([]);
 useEffect(()=>{if(!canManage)return;const controller=new AbortController();
  void api<{items:Array<{id:string;question:string;engineName:string;overdue:boolean}>}>(withBuildingScope(`/api/engine-decisions?documentId=${documentId}&limit=20`,building),{signal:controller.signal})
   .then(value=>setItems(value.items)).catch(()=>setItems([]));
  return()=>controller.abort();
 },[documentId,building,canManage]);
 if(!items.length)return null;
 return <section className="panel notice-info" aria-label="Needs details"><h2>Needs details</h2>
  <p>This document was filed with {items.length===1?'one detail':`${items.length} details`} still to confirm. The blank details were not filled with a guess.</p>
  <ul>{items.map(q=><li key={q.id}><Link to={`/work/questions/${q.id}?documentId=${encodeURIComponent(documentId)}&assigned=all`}>{q.question}</Link> · {q.engineName}{q.overdue?' · Overdue':''}</li>)}</ul>
 </section>;
}
